"use client";
import { useNavigate, useParams } from "react-router-dom";
import {
  useFetchApplicationDetails,
  useInstallApplicationMutation,
} from "../../../apis/integrationApis";
import { IconChevronLeft } from "@tabler/icons-react";
import { useForm } from "react-hook-form";
import Input from "../../../components/Input";
import toast from "react-hot-toast";

const FillInstallationDetails = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<any>();

  const { id } = useParams();
  const navigate = useNavigate();
  const { data } = useFetchApplicationDetails(id ?? "");
  const { mutate, isPending } = useInstallApplicationMutation(id ?? "");

  const handleInstall = (formData: any) => {
    mutate(formData, {
      onSuccess: (res) => {
        console.log(res?.data?.clientId,'data')
        toast.success("Application installed successfully!");
        reset();
        navigate(`/integration/${id}/connect/${res?.data?.id}`)
      },
      onError: (error) => {
        console.log(error, "error");
        toast.error(`${error}`);
      },
    });
  };

  return (
    <div className="w-full max-w-5xl mx-auto px-6 py-8">
      {/* Header */}
      <div className="flex items-center gap-3 mb-8">
        <button
          onClick={() => navigate(-1)}
          className="p-2 border border-gray-300 rounded-full hover:bg-gray-100 transition"
        >
          <IconChevronLeft strokeWidth={1.5} size={22} />
        </button>
        <div className="flex items-center gap-3">
          <img
            src={data?.companyLogo || "/img/image (6).png"}
            className="w-12 h-12 rounded-xl object-contain border border-gray-200"
            alt={data?.companyName}
          />
          <h1 className="text-2xl font-semibold text-gray-900">
            {data?.companyName}
          </h1>
        </div>
      </div>

      {/* Form */}
      <form
        onSubmit={handleSubmit(handleInstall)}
        className="bg-white shadow-md rounded-2xl p-8 border border-gray-100"
      >
        <h2 className="text-lg font-medium text-gray-800 mb-6">
          Installation Details
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Account No */}
          <div>
            <Input
              title="Account No"
              name="accountNo"
              placeholder="Enter Account No"
              register={register}
              validation={{ required: "Account No is required" }}
            />
            {errors.accountNo && (
              <p className="text-sm text-red-500 mt-1">
                {errors.accountNo.message as string}
              </p>
            )}
          </div>

          {/* Secret Key */}
          <div>
            <Input
              title="Secret Key"
              name="secretKey"
              placeholder="Enter Secret Key"
              register={register}
              validation={{ required: "Secret Key is required" }}
            />
            {errors.secretKey && (
              <p className="text-sm text-red-500 mt-1">
                {errors.secretKey.message as string}
              </p>
            )}
          </div>
        </div>

        {/* Submit Button */}
        <div className="mt-8 flex justify-end">
          <button
            type="submit"
            disabled={isPending}
            className="px-6 py-2.5 flex items-center gap-2 rounded-lg bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-semibold shadow hover:from-yellow-500 hover:to-yellow-600 transition disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {isPending && (
              <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
            )}
            {isPending ? "Installing..." : "Install"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default FillInstallationDetails;
